const {
  MOLDOVAN_BID_MIN,
  MOLDOVAN_BID_MAX,
  MOLDOVAN_BID_STEP,
  MOLDOVAN_GAME_MODES,
} = require("./moldovanConstants");

const MODE_PRIORITY = Object.freeze({
  "s": 1,
  "d": 2,
  "h": 3,
  "c": 4,
  [MOLDOVAN_GAME_MODES.noTrumps]: 5,
  [MOLDOVAN_GAME_MODES.allTrumps]: 6,
});

function clampBidPoints(points) {
  const p = Number(points);
  if (!Number.isFinite(p)) return MOLDOVAN_BID_MIN;
  const aligned = Math.round(p / MOLDOVAN_BID_STEP) * MOLDOVAN_BID_STEP;
  return Math.max(MOLDOVAN_BID_MIN, Math.min(MOLDOVAN_BID_MAX, aligned));
}

function normalizeBid(rawBid) {
  if (!rawBid || typeof rawBid !== "object") return null;
  const points = clampBidPoints(rawBid.points);
  const mode = Object.values(MOLDOVAN_GAME_MODES).includes(rawBid.mode)
    ? rawBid.mode
    : MOLDOVAN_GAME_MODES.trump;
  const trumpSuit = mode === MOLDOVAN_GAME_MODES.trump ? Number(rawBid.trumpSuit ?? 0) : null;
  return { points, mode, trumpSuit };
}

function isBidStronger(nextBid, currentBid) {
  if (!nextBid) return false;
  if (!currentBid) return true;
  const nextPoints = Number(nextBid.points);
  const currentPoints = Number(currentBid.points);
  if (nextPoints > currentPoints) return true;
  if (nextPoints < currentPoints) return false;
  const np = Number(MODE_PRIORITY[nextBid.mode] || 0);
  const cp = Number(MODE_PRIORITY[currentBid.mode] || 0);
  return np > cp;
}

function resolveStrictBait({
  contractPoints,
  contractTeamTotal,
  defendersRoundTotal,
  contractTeam,
}) {
  const success = Number(contractTeamTotal) >= Number(contractPoints);
  if (success) return { success: true, delta: null };
  const ct = Number(contractTeam);
  const sweep = Number(contractTeamTotal) + Number(defendersRoundTotal);
  return {
    success: false,
    delta: ct === 0 ? [0, sweep] : [sweep, 0],
  };
}

module.exports = {
  clampBidPoints,
  normalizeBid,
  isBidStronger,
  MODE_PRIORITY,
  resolveStrictBait,
};
